type Props = {
    isLive: boolean;
    isTimedPlus: boolean;
    lotsAreClosing: boolean;
    saleStartTs: number;
};

export enum ImageClusterVariant {
    Live = 'live',
    TimedPlusInProgress = 'timedPlusInProgress',
    CoverLots = 'coverLots',
}

export const getHeaderImageClusterVariant = ({
    isLive,
    isTimedPlus,
    lotsAreClosing,
    saleStartTs,
}: Props): ImageClusterVariant => {
    if (isTimedPlus && lotsAreClosing) {
        return ImageClusterVariant.TimedPlusInProgress;
    }

    if (isLive && saleStartTs > 0 && !isTimedPlus) {
        return ImageClusterVariant.Live;
    }

    return ImageClusterVariant.CoverLots;
};
